var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading)?_c('Loading',{attrs:{"active":_vm.loading,"is-full-page":false,"opacity":0},on:{"update:active":function($event){_vm.loading=$event}}}):_vm._e(),(_vm.job)?_c('PreviewJobBody',{attrs:{"job":_vm.job}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }